export enum CommentEntityNameEnum {
  Thread = 'thread',
  Comment = 'comment',
  Resource = 'resource',
}
